import React from 'react';
import { Tooltip } from 'antd';

const ONLINE_WINDOW_MS = 5 * 60 * 1000;

/** "3 days ago" style text for an ISO time, from the platform's own Intl (no library). */
export const relativeTime = (iso: string): string => {
  const seconds = Math.round((new Date(iso).getTime() - Date.now()) / 1000);
  const units: Array<[Intl.RelativeTimeFormatUnit, number]> = [
    ['year', 31536000], ['month', 2592000], ['day', 86400], ['hour', 3600], ['minute', 60]
  ];
  const formatter = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  for (const [unit, size] of units) {
    if (Math.abs(seconds) >= size) return formatter.format(Math.round(seconds / size), unit);
  }
  return formatter.format(seconds, 'second');
};

const full = (iso?: string | null) => (iso ? new Date(iso).toLocaleString() : 'Never');

/**
 * "Online" when the person used the app in the last five minutes, otherwise how long ago they
 * were last active. The tooltip gives both exact times (app activity and last sign-in).
 */
const Presence = ({ lastSeenAt, lastLoginAt }: { lastSeenAt?: string | null; lastLoginAt?: string | null }) => {
  const seenMs = lastSeenAt ? new Date(lastSeenAt).getTime() : NaN;
  const online = !Number.isNaN(seenMs) && Date.now() - seenMs <= ONLINE_WINDOW_MS;
  const latest = lastSeenAt || lastLoginAt;
  const tip = (
    <div>
      <div>Last active: {full(lastSeenAt)}</div>
      <div>Last sign-in: {full(lastLoginAt)}</div>
    </div>
  );
  let body: React.ReactNode;
  if (online) {
    body = (
      <span className="inline-flex items-center gap-1.5">
        <span
          style={{ 
            width: 8, 
            height: 8, 
            borderRadius: '50%', 
            background: '#22c55e', 
            display: 'inline-block' 
          }}
        />
        Online
      </span>
    );
  } else if (latest) {
    body = <span 
      className="text-gray-500"
    >Active {relativeTime(latest)}</span>;
  } else {
    body = <span className="text-gray-400">Never</span>;
  }
  return <Tooltip title={tip}>{body}</Tooltip>;
};

export default Presence;
